import shortcuts from '../../json/shortcuts.json'

export const EditorShortCuts = ({onClose}) => {
 
  return (
    <>
    <div className="w-full flex flex-col justify-between h-full overflow-auto right-panel-scroll max-h-[calc(100%-10px)]">
      <div className="w-full">
        <div className="border-b border-grey p-3  absolute top-0 bg-leftPanelbg inset-x-0 z-[10] ">
          <h4 className="font-semibold text-primary text-[18px]">
            Editor Shortcuts
          </h4>
        </div>
        <div className="space-y-2 mt-14 ">
          {shortcuts.map(({ keys, name }) => (
            <div
              key={keys}
              className="flex items-center gap-1 justify-between bg-grey text-leftPanel rounded-md p-2 shadow-sm"
            >
              <p className="text-18 font-medium text-leftPanel">{name}</p>
              <kbd className="bg-gray-200 border border-gray-400 rounded px-2 py-1 text-sm font-mono text-gray-700">
                {keys}
              </kbd>
            </div>
          ))}
        </div>
      </div>
      
    </div>
    <button
              onClick={onClose}
              className="w-full bg-[#0060CE] rounded-[8px] text-white py-2 "
            >
              Close
            </button></>  );
};
